import * as echarts from "echarts";

export interface SeriePonto {
  timestamp: string;
  valor: number;
}

export interface SerieConfig {
  eixo: "principal" | "secundario";
}

/**
 * Line chart de series nomeadas (ex: uma por tag) sobre o tempo. Series com
 * config.eixo = 'secundario' vao pro eixo Y da direita (ex: comparar duas
 * grandezas de escalas bem diferentes, tipo temperatura x nivel do rio).
 * Zoom com o mouse: scroll/arrastar (dataZoom 'inside'), slider embaixo, ou
 * o botao de zoom por caixa na toolbox (arrasta um retangulo sobre o
 * periodo desejado).
 */
export function renderLineChart(
  el: HTMLElement,
  series: Record<string, SeriePonto[]>,
  config: Record<string, SerieConfig> = {}
): echarts.ECharts {
  // echarts.init mantem a instancia anterior vinculada ao elemento mesmo apos
  // el.innerHTML = "" (o marcador fica no proprio node, nao nos filhos) - sem
  // dispose, init() reaproveita a instancia velha (sem canvas) e nada aparece.
  const existente = echarts.getInstanceByDom(el);
  if (existente) existente.dispose();
  const chart = echarts.init(el);
  const nomes = Object.keys(series);
  const usaSecundario = nomes.some((nome) => config[nome]?.eixo === "secundario");

  chart.setOption({
    tooltip: { trigger: "axis" },
    legend: { data: nomes, bottom: 0 },
    toolbox: {
      right: 16,
      feature: {
        dataZoom: { yAxisIndex: "none", title: { zoom: "Zoom (arraste no gráfico)", back: "Resetar zoom" } },
        restore: { title: "Resetar" },
      },
    },
    grid: { left: 50, right: usaSecundario ? 60 : 24, top: 44, bottom: 76 },
    xAxis: { type: "time" },
    yAxis: usaSecundario
      ? [
          { type: "value", name: "Principal", position: "left" },
          { type: "value", name: "Secundário", position: "right" },
        ]
      : { type: "value" },
    dataZoom: [
      { type: "inside" },
      { type: "slider", height: 18, bottom: 30 },
    ],
    series: nomes.map((nome) => ({
      name: nome,
      type: "line",
      smooth: true,
      showSymbol: false,
      ...(usaSecundario ? { yAxisIndex: config[nome]?.eixo === "secundario" ? 1 : 0 } : {}),
      data: series[nome].map((p) => [p.timestamp, p.valor]),
    })),
  });

  return chart;
}
